import React, { FC, useState } from 'react';
import { Redirect, useLocation } from 'react-router-dom';
import AuthLayout from 'components/AuthLayout';
import { getAccessToken, getRefreshToken, resetStorage } from 'utils/auth';
import AddToHomeScreenComponent from 'components/add-to-homescreen/AddToHomeScreenComponent';
import { useTranslation } from 'react-i18next';

import LoginForm from './components/LoginForm';
import AuthCodeForm from './components/AuthCodeForm';

const LoginScreen: FC = () => {
  const [isLoginFormVisible, setIsLoginFormVisible] = useState(true);
  const { t } = useTranslation();
  const isUserAuthorized = getAccessToken();
  const location = useLocation<{ from?: { pathname: string }; email?: string }>();
  const [state] = useState(location?.state);
  const isMobile = window.innerWidth <= 768;

  /**
   * If user has logged in but has 2FA enabled
   * he has to provide 2FA code to complete login
   * and to get a valid refresh token
   */
  const isUserLoginComplete = getRefreshToken();

  /**
   * If user is already logged in and login is complete,
   * redirect to admin or client home page
   *
   * Else If login is not complete - reset storage
   *
   * Else just show login form
   */
  if (isUserAuthorized && isUserLoginComplete) return <Redirect to="/home" />;

  return (
    <AuthLayout title={t('auth.login.title')}>
      {isLoginFormVisible && <LoginForm goTo2FALogin={() => setIsLoginFormVisible(!isLoginFormVisible)} />}
      {!isLoginFormVisible && (
        <AuthCodeForm
          goBack={() => setIsLoginFormVisible(!isLoginFormVisible)}
          redirectState={state}
        />
      )}
      {isMobile && isLoginFormVisible && (
        <div className="text-center">
          <hr />
          <AddToHomeScreenComponent
            label="addToHomescreen.install"
            type="button"
          />
        </div>
      )}
    </AuthLayout>
  );
};

export default LoginScreen;
